import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface HelpDeskUserLoginListItemDTO {
  id: string;
  userLogin: string;
  comment: string;
  disabled: boolean;
}
const HelpDeskUserLoginListItemDTO = {
  create: (initValues?: Partial<HelpDeskUserLoginListItemDTO>): HelpDeskUserLoginListItemDTO => {
    const defaults: HelpDeskUserLoginListItemDTO = {
      id: '',
      userLogin: '',
      comment: '',
      disabled: false,
    };
    const fixedInitValues: Partial<HelpDeskUserLoginListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default HelpDeskUserLoginListItemDTO;
